// ----------------------------------------------------------------------

export default function Paper(theme) {
  const isDarkMode = theme.palette.mode === 'dark';
  
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },

      variants: [
        {
          props: { variant: 'outlined' },
          style: { 
            borderColor: isDarkMode ? '#595959' : theme.palette.grey[500_12],
            borderRadius: '24px',
            boxShadow: isDarkMode ? '0px 0px 4px rgba(0, 0, 0, 0.25)' : '0px 0px 4px rgba(0, 0, 0, 0.1)',
          },
        },
      ],

      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: isDarkMode ? '#151A1E' : theme.palette.background.paper,
          borderRadius: '24px',
          boxShadow: isDarkMode ? '0px 0px 4px rgba(0, 0, 0, 0.25)' : '0px 0px 4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  };
}
